import { createTheme, responsiveFontSizes } from '@mui/material/styles';

export default function GlobalStyleOverrides() {
    const theme = createTheme({       
      typography: {
        fontFamily: [
          '"Inter-Medium"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
        ].join(','),         
        body1: {
          fontFamily: "'Inter-Medium', Arial, sans-serif",
        },
      },
    });
  
    return responsiveFontSizes(theme);
  }